import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ReachSucessComponent } from '../reach-success/reach-success.component';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ReachedService } from '../../services/raintree/Transmission/pending-reach.service';
import { LocationService } from '../../services/common/location.service';
import { error } from 'console';
import { ReachAlertPopupComponent } from './reach-alert-popup/reach-alert-popup.component';

@Component({
  selector: 'app-reach-defaulter-popup',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './reach-defaulter-popup.component.html',
  styleUrl: './reach-defaulter-popup.component.scss',
})
export class ReachDefaulterPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ReachDefaulterPopupComponent>,
    private toaster: ToastrService,
    private pendingReachService: ReachedService,
    private location: LocationService 
  ) {}
  reachSuccess: boolean = true;
  isLoading: boolean = false;

  ngOnInit() {
    this.notes = new FormControl('');
    console.log(this.data.reachedBy);
  }
  notes!: FormControl;
  onCancelClick() {
    this.dialogRef.close();
  }
  testing() {
    console.log(this.notes.value);
  }
  onReachedClick() {
    this.isLoading = true;
    this.location.isLocationGranted().subscribe((isGranted: boolean)=>{
      if(isGranted){
    if (this.notes.value.length != 0) {
      console.log('123');
      
      this.location.getCurrentPosition().subscribe({
        next: (position) => {
          console.log('123');
          const lat = position.coords.latitude.toString();
          const long = position.coords.longitude.toString();
          const reqData = {
            memKey: this.data.slno,
            memberCode: this.data.memberCode,
            notes: this.notes.value,
            lat: lat,
            long: long
          };
          this.pendingReachService.addReach(reqData).subscribe( {
            next: (response: any) => {
              console.log(response);
              const dialogRef = this.dialog.open(ReachSucessComponent,{
                panelClass: 'common-pannel-dialog-container',            
              });
              this.dialogRef.close(this.reachSuccess);
            },
            error: (error) => {
              console.log(error.message);
              this.toaster.error(error);
            },
          });
          console.log(reqData);
          this.isLoading = false;
        },
        error: (error) =>{
          console.log(error.message);
          this.toaster.error(error);
          this.isLoading= false;
        }
        })
          } else {this.toaster.error('Enter Notes to add member in Reach');
            this.isLoading = false;
          }
        }else{
          
          this.dialog.open(ReachAlertPopupComponent, {
            data: {message: ' You cannot Reach until you turn on location services.'}
          })
          this.isLoading = false;
        }
      })

          }
        
        
      
    
  }
